
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import React from 'react';
import '../../stylesheet/regmodal.css';




const ActivationSuccess = props => {

    return (
        <Modal
            open={props.open}
            className="col-sm-12 flow-modal">
            <div
                className="modal-content col-sm-6"
                style={{ background: "#fff", color: "#fff" , minHeight:"300px" }}>
                <div
                    position="static"
                    className="modal-header"
                    style={{ background: "#fff", padding: "10px" }}>
                    <div className="col-sm-12">
                        <div className="row">
                            {/* <div
                                className="col-sm-6"
                                style={{ fontSize: "19px", fontWeight: "600", color: "#fff" }}>
                                <span>Status</span>
                            </div> */}
                            <div
                                className="col-sm-12"
                                style={{ float: "right" }}>
                                <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    style={{ marginTop: "-19px", color: "#333" }}
                                    onClick={props.onClose}
                                    aria-label="Close">
                                    <span
                                        aria-hidden="true"
                                        style={{ color: "#333", fontSize: "30px" }}>
                                        &times;
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="modal-body text-left"
                    style={{ color: "#3e3e3e" }}>
                    <div className="col-sm-12">
                        <div className="col-sm-12" >
                            <i
                                className="fa fa-flag-checkered fa-4x mb-3 animated rotateIn"
                                style={{ color: "#323435" }}>
                            </i>
                        </div>
                        <div
                            className="col-sm-12"
                            style={{ fontSize: "20px", fontWeight: "600", marginBottom: "15px",  color: "green" }}>
                            {props.message}
                        </div>
                        <div className="col-sm-12" style={{ fontSize: "14px" }}>
                            <div className="row col-md-12" style={{ display: "flex", justifyContent: "left" }}>
                                <div className="" >
                                    <Button className="btn btn-std" onClick={props.onClose} >
                                        Ok
                                    </Button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ActivationSuccess


// WEBPACK FOOTER //
// ./src/components/register/activationsuccess.jsx